/* import __COLOCATED_TEMPLATE__ from './popover-item.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type { UserField } from 'embercom/objects/standalone/data-fields/zendesk-user-field';
import type { OrganizationField } from 'embercom/objects/standalone/data-fields/zendesk-organization-field';
import type { TicketField } from 'embercom/objects/standalone/data-fields/zendesk-ticket-field';
import type ExternalFieldIdentifier from 'embercom/models/standalone/external-field-identifier';

type Field = UserField | OrganizationField | TicketField | ExternalFieldIdentifier;

export interface Args {
  field: Field;
  synchronizeField: (field: Field) => void;
  popover: { hide: () => void };
}

interface Signature {
  Args: Args;
}

export default class PopoverItem extends Component<Signature> {
  @service declare finStandaloneService: FinStandaloneService;

  get canBeSynchronized() {
    if (!('canBeSynchronized' in this.args.field)) {
      return true;
    }
    return this.args.field.canBeSynchronized;
  }

  get controllerFieldExternalId() {
    if (!('controllerFieldExternalId' in this.args.field)) {
      return;
    }
    return this.args.field.controllerFieldExternalId;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::DataField::PopoverItem': typeof PopoverItem;
    'standalone/data-field/popover-item': typeof PopoverItem;
  }
}
